var SegmentSet = (function () {
    function SegmentSet() {
    }
    return SegmentSet;
}());
export { SegmentSet };
